<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <div class="table-top">
          <div class="order-num">订单号：{{order_id}}</div>
          <div class="search">
            <span class="search-txt">请输入要添加的仪器名称回车</span>
            <el-input
              class="search-input"
              placeholder="请输入搜索内容"
              v-model="search_name"
              :header-cell-style="getRowClass"
              prefix-icon="el-icon-search" @keyup.enter.native="searchName">
            </el-input>
          </div>
        <el-button class="new-btn" @click="scanAddDevice">扫码添加</el-button>
        <el-button class="new-btn" @click="seeDetail">添加完成</el-button>
        </div>
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          :empty-text="empty"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="device_name"
            label="仪器名称">
          </el-table-column>
          <el-table-column
            prop="measure"
            label="范围">
          </el-table-column>
          <el-table-column
            prop="grade"
            label="等级">
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button
                class="add-btn"
                @click="handleAdd(scope.row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-container">
          <el-pagination
            background
            layout = "total, prev, pager, next"
            v-if="total>0"
            :page-size="limit"
            :total = "total"
            :current-page = "page"
            @current-change = "currentPageFun"
            >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 点击添加的弹出框 start -->
    <el-dialog
      title="添加仪器"
      class="dialog-container"
      :visible.sync="dialogAdd">
      <div class="form-title">仪器信息</div>
      <el-form class="form-container" :model="device" :rules="deviceRule" ref="device">
        <el-form-item label="仪器名称" class="input-list">
          <p class="input-txt">{{device.device_name}}</p>
        </el-form-item>
        <el-form-item label="仪器范围" class="input-list">
          <p class="input-txt">{{device.measure}}</p>
        </el-form-item>
        <el-form-item label="仪器等级" class="input-list">
          <p class="input-txt">{{device.grade}}</p>
        </el-form-item>
        <el-form-item class="input-list" label="校准方式">
          <el-radio-group class="radio-content" @change="radioChange" v-model="device.measure_type">
            <el-radio class="radio-list" :label="0">校准</el-radio>
            <el-radio class="radio-list" :label="2">检测</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="input-list" label="服务类型" >
          <el-radio-group class="radio-content" @change="serveChange" v-model="device.service_type">
            <el-radio class="radio-list" :label="0">自校送检</el-radio>
            <el-radio class="radio-list" :label="1">自校上门</el-radio>
            <el-radio class="radio-list" :label="2">委外送检</el-radio>
            <el-radio class="radio-list" :label="3">委外上门</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 服务类型 委外送检 或者委外上门 选择实验室 -->
        <el-form-item class="input-list" label="实验室"  v-if="options.length > 0">
          <el-select class="options-select" v-model="device.service_lab_id" placeholder="请选择实验室">
            <el-option
              v-for="item in options"
              :key="item.lab_id"
              :label="item.name"
              :value="item.lab_id">
            </el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="数量" class="input-list input-top" prop="amount">
          <el-input type="text" v-model="device.amount" placeholder="请输入数量"></el-input>
        </el-form-item>
        <el-form-item label="送检日期" class="input-list input-top">
          <el-date-picker
            class="date-input"
            type="date"
            v-model="device.next_date"
            placeholder="请选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="器具编号" class="input-list input-top" prop="aequip_code">
          <el-input type="text" v-model="device.equip_code" placeholder="请输入器具编号"></el-input>
        </el-form-item>
        <el-form-item label="生产厂家" class="input-list input-top" prop="vendor">
          <el-input type="text" v-model="device.vendor" placeholder="请输入生产厂家"></el-input>
        </el-form-item>
        <el-form-item class="input-list input-top" label="备注">
          <el-input
            class="txt-area"
            type="textarea"
            v-model="device.memo"
            placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item class="btn-list">
          <el-button class="btn-save" @click="saveDevice('device')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 点击添加 出现的弹窗框 end -->
    <!-- 点击扫码添加按钮的 弹出框 start -->
      <div  class="delete-container" v-if="addShow&&imgSrc.length>0">
        <div class="delete-content">
          <i class="el-icon-close close-icon" @click="cancleDelete"></i>
          <div class="img-container">
            <img class="code-img" :src="imgSrc" alt="">
          </div>
        </div>
      </div>
    <!-- 点击扫码添加按钮的 弹出框 end -->
  </div>
</template>

<script type='text/ecmascript-6'>
import moment from 'moment'
export default {
  data () {
    var amountRule = (rule, value, callback) => {
      let reg =  /^\+?[1-9][0-9]*$/
      if (!reg.test(value)) {
        return callback(this.$message({
          type: 'error',
          message: '仪器数量要为正整数',
          customClass: 'msg-position',
          showClose: true
        }))
      } else {
        return callback()
      }
    }
    return {
      empty: '请搜索仪器的名称',
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      addShow: false,
      imgSrc: '',
      search_name: '',
      dialogAdd: false,
      device: {},
      chooseDate: moment(new Date()).format('YYYY-MM-DD'),
      deviceRule: {
        amount: [{validator: amountRule, trigger: 'blur'}]
      },
      options: []
    }
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    initData () {
      this.order_id = this.$route.params.order_id
    },
    searchName () { // 输入搜索的名字
      let that = this
      if (this.search_name) {
        this.$api.createSearchDevice({
          device_name: that.search_name,
          page_num: (that.page-1) * that.limit
        }).then(res => {
          if (res.data.detail.length > 0) {
            that.tableData = res.data.detail
            that.total = Number(res.data.total)
          } else {
            that.tableData  = []
            that.total = 0
            that.empty = '没有搜索的仪器！！'
          }
        }).catch(e => {
          that.$message({
            type: 'error',
            massage: `${e}`,
            customClass: 'msg-position',
            showClose: true
          })
        })
      } else {
        that.$message({
          type: 'error',
          message: '输入不能为空！',
          customClass: 'msg-position',
          showClose: true
        })
      }
    },
    handleAdd (row) { // 点击添加按钮
      this.dialogAdd = true
      this.device = {...row, measure_type: 0,service_type: 0,amount: 1, next_date: this.chooseDate, memo: '', service_lab_id: 0, equip_code: '', vendor: ''}
    },
    saveDevice (formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.$api.orderAddDevice({
            order_id: that.order_id,
            measure_type: that.device.measure_type,
            service_type: that.device.service_type,
            amount: that.device.amount,
            device_cat_id: that.device.device_cat_id,
            skill_id: that.device.skill_id,
            memo: that.device.memo,
            service_lab_id: that.device.service_lab_id,
            next_date: moment(new Date(that.device.next_date)).format('YYYY-MM-DD'),
            equip_code: that.device.equip_code,
            vendor: that.device.vendor,
            dev_name: that.device.device_name
          }).then(res => {
            if (res.data.msg === true) {
              that.$message({
                type: 'success',
                message: '仪器添加成功！！',
                customClass: 'msg-position',
                showClose: true
              })
              that.dialogAdd = false
            } else {
              that.$message({
                type: 'error',
                message: '仪器添加失败！！',
                customClass: 'msg-position',
                showClose: true
              })
            }
          }).catch(e => {
            that.$message({
              type: 'error',
              message: `${e}`,
              customClass: 'msg-position',
              showClose: true
            })
          })
        }
      })
    },
    scanAddDevice () { // 点击扫码添加按钮
      this.initImg()
    },
    initImg () { // 点击扫码添加获取 二维码
      let that = this
      this.$api.scanQrcode({
        scan_type: `a${this.order_id}`
      }).then(res => {
        if (res.data.msg === true) {
          that.imgSrc = res.data.qrcode_url
          that.addShow = true
        } else {
          that.$message({
            showClose: true,
            message: '缺少委托单号',
            type: 'error',
            customClass: 'msg-position'
          })
        }
      })
    },
    cancleDelete () { // 取消删除
      this.addShow = false
      this.$message({
        type: 'info',
        message: '取消此操作！',
        customClass: 'msg-position',
        showClose: true
      })
    },
    radioChange (val) {
      this.device.measure_type = val
    },
    serveChange(val) {
      this.device.service_type = val
    },
    getLabs() {
      let that = this
      that.$api.getLabs({}).then(res => {
        that.options = res.data
        that.device.service_lab_id = res.data[0].lab_id
      })
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
    },
    seeDetail() {
      this.$router.push({
        path: '/orderDetail',
        query: { lab_order_id: this.order_id, type: 0}
      })
    }
  },
  components: {
  },
  watch: {
    /* '$route': 'initData', */
    page () {
      this.searchName()
    },
    'device.service_type'(val) {
      if(val == 2|| val == 3) {
        this.getLabs()
      } else {
        this.device.service_lab_id = 0
        this.options = []
      }
    }
  }
}
</script>

<style lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/box.styl'
@import '~common/stylus/deletebox.styl'
.order-num
  font-size: 0.75rem;
  color: #999;
.search-txt
  font-size: 0.75rem;
  color: #999;
  margin-right: 0.3rem;
.add-btn
  background: #48BEAA;
  border-radius: 0.01rem;
  height:1.4rem;
  padding: 0 0.5rem;
.btn-save
  background:#1D489E;
  span
    color:#fff;
</style>

